import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IClient } from '../models/book-of-business.interface';
import { BookOfBusinessRepository } from '../repositories/book-of-business.repository';

@Injectable({
  providedIn: 'root',
})
export class BookOfBusinessService {

  constructor(private bookOfBusinessRepository: BookOfBusinessRepository) {}

  getBookOfBusiness(): Observable<IClient[]> {
    return this.bookOfBusinessRepository.getBookOfBusiness();
  }
}
